import React from "react";

export const HeaderRedPresentation = ({ name = "" }) => {
	return (
		<div className="fixed z-30 top-5 left-1/2 transform -translate-x-1/2 py-3 md:py-4 px-10 bg-red_primary rounded-2xl flex justify-center items-center">
			<p className="text-white font-semibold">{name}</p>
		</div>
	);
};
